# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://coffeescript.org/

$(document).on "turbolinks:load", ->
  $(".show-blackboard_ultra-alert-on-click").on("click", (e) ->
    $("#extra-blackboard-ultra-alert").show()
  )

  $(".show-blackboard-alert-on-click").on("click", (e) ->
    $("#extra-blackboard-alert").show()
  )

  $(".show-d2l-alert-on-click").on("click", (e) ->
    $("#extra-d2l-alert").show()
  )

  $(document).on("click", (e) ->
    if $(".actions-menu").is(":visible")
      $(".modal-backdrop").css("opacity", "0")
  )